import React from 'react'
import {Card, Grid, Header, } from 'semantic-ui-react'
import {resume} from './resume'
import YouTube from 'react-youtube';

export default class Publication extends React.Component {
    _onReady(event) {
        event.target.pauseVideo();
    }
    _onPlay(event) {
        console.log(window.innerWidth)
        if (window.innerWidth > 800) {
            event.target.setSize(640, 390)
        }
    }

    publicationInfo = () => {
        const infos = resume.publications;
        const opts = {
            height: '195',
            width: '320',
            playerVars: {
                autoplay: 0
            }
        };      
        return (
            <Grid divided='vertically' className='publication'>
                {infos.map((key,id) => {
                    if (key.videoId) {
                        var videoDom = (
                            <YouTube
                                videoId={key.videoId}
                                opts={opts}
                                onReady={this._onReady}
                                onPlay={this._onPlay}
                            />
                        )
                    }
                    return (
                        <Grid.Row key={id}>
                            <Grid.Column textAlign='left'>
                                <Header as='h4'>
                                    {key.title}
                                </Header>
                                <Header as='h5'>
                                    {key.publisher + ' ' + key.award}
                                </Header>
                                {videoDom}
                            </Grid.Column>
                        </Grid.Row>
                    );
                })}
            </Grid>
        )
    }
    render() {
        const pubDom = this.publicationInfo();
        return (
            <Card id='publication' className='summary' fluid>
                <Card.Content>
                    <Card.Header textAlign='left'>Publication</Card.Header>
                </Card.Content>
                <Card.Content>
                    <Grid>
                        {pubDom}
                    </Grid>
                </Card.Content>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Infos/publication.js